import { createRouter, createWebHistory } from 'vue-router'
import store from '../store';
import HomeView from '../views/dashboard/HomeView.vue'
import ClavesPendientesTable from '../views/ClavesPendientes/ClavesPendientesTable.vue'
import ClavesFinalesTable from '../views/ClavesFinales/ClavesFinalesTable.vue'
import BuscarPremio from '../views/BuscarPremio/BuscarPremio.vue'
import GestionPremios from '../views/GestionPremios/GestionPremios.vue'
import HomePublic from '../views/public/HomePublic.vue'
import UserLogin from '../views/login/UserLogin.vue';
import FormularioRegistrarse  from '../views/login/FormularioRegistrarse .vue';
import QrPendiente from '../views/QrPendiente/QrPendiente.vue';
import CheckResult from '../views/CheckResult/CheckResult.vue';


const routes = [
  {
    path: '/check-result-p/:token',
    name: 'QrPendiente',
    component: QrPendiente,
    props: true, // Permite pasar el parámetro `token` como una prop al componente
  },
  {
    path: '/check-result/:token',
    name: 'CheckResult',
    component: CheckResult,
    props: true, // Permite pasar el parámetro `token` como una prop al componente
  },
  {
    path: '/',
    name: 'HomePublic',
    component: HomePublic,
  },
  {
    path: '/login',
    name: 'UserLogin',
    component: UserLogin,
  },
  {
    path: '/registrarse/:clave?',
    name: 'FormularioRegistrarse',
    component: FormularioRegistrarse,
    props: route => ({ claveProp: route.params.clave }) // Aquí pasas el parámetro como prop al componente
  },
  {
    path: '/dashboard',
    name: 'UserDashboard',
    component: HomeView,
    meta: {
      requiresAuth: true,
    },    
  },
  {
    path: '/dashboard/claves-pendientes',
    name: 'ClavesPendientesTable',
    component: ClavesPendientesTable,
    meta: {
      requiresAuth: true,
    },    
  },
  {
    path: '/dashboard/claves-finales',
    name: 'ClavesFinalesTable',
    component: ClavesFinalesTable,
    meta: {
      requiresAuth: true,
    },    
  },
  {
    path: '/dashboard/buscar-premio',
    name: 'BuscarPremio',
    component: BuscarPremio,
    meta: {
      requiresAuth: true,
    },    
  },
  {
    path: '/dashboard/gestion-premios',
    name: 'GestionPremios',
    component: GestionPremios,
    meta: {
      requiresAuth: true,
    },    
  },
  // {
  //   path: '/dashboard/user/edit/:token', // Asegúrate de que el token es el parámetro correcto que necesitas
  //   name: 'EditUser',
  //   component: EditUser,
  //   props: true // Esto permite que el token se pase como una prop al componente
  // },
  // {
  //   path: '/user-details/:userId',
  //   name: 'UserDetails',
  //   component: () => import('../components/metrics/UserMetrics/DetaillUser.vue'),
  //   props: true,
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
  // {
  //   path: '/dashboard/usuarios/agregar-usuario/:groupId',
  //   name: 'AgregarUsuario',
  //   component: AgregarUsuario,
  //   props: true,
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
  // {
  //   path: '/registrarse/:clave?',
  //   name: 'Registrarse',
  //   component: Registrarse,
  //   props: route => ({ claveProp: route.params.clave }) // Aquí pasas el parámetro como prop al componente
  // },
  // {
  //   path: '/403',
  //   name: 'Forbidden',
  //   component: Forbidden
  // },
  // {
  //   path: '/dashboard/usuarios',
  //   name: 'DashboardUsuarios',
  //   component: DashboardUsuarios,
  //   meta: { requiresAuth: true }  // Sólo asegura que el usuario debe estar autenticado para acceder
  // }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Guarda global
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // Verifica si el usuario está autenticado en el estado Vuex
    if (!store.state.isLoggedIn) {
      // Redirige al usuario a /login si no está autenticado
      return next('/login');
    }
  }
  // Si la ruta no está protegida o el usuario está autenticado, continúa
  next();
});

export default router
